import { authedJson } from './client';
import { API_ROUTES } from '../../../shared/api';
import type { DuelLobby } from '../../../shared/types';

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

/** Duel room endpoints (auth required). Real-time play runs over the WebSocket. */
export const duelApi = {
  /** Create a new duel room hosted by the caller. */
  create: (getToken: GetToken, refresh: DoRefresh) =>
    authedJson<DuelLobby>(API_ROUTES.duels, { method: 'POST' }, getToken, refresh),

  /** Fetch a duel's lobby state (to render the join screen). */
  get: (id: string, getToken: GetToken, refresh: DoRefresh) =>
    authedJson<DuelLobby>(API_ROUTES.duel(id), { method: 'GET' }, getToken, refresh),
};
